<template>
  <div
    class="notification-toast max-w-sm
    flex justify-between
    border border-l-4 py-5 px-4 mb-2"
    :class="[borderColor, backgroundColor]"
  >
    <div
      class="notification-toast__first-half
      flex gap-4"
    >
      <span
        :class="iconClass"
        class="h-4 flex items-center flex-shrink-0"
      />
      <div
        class="notification-toast__explanation text-sm"
      >
        <div class="explanation__title font-bold">
          {{ title }}
        </div>
        <div class="explanation__subtitle">
          {{ subtitle }}
          <SimpleLink
            v-if="endingLinkText"
            class="underline text-EXPONDO-primary-60"
            :to="endingLinkSlug"
          >
            {{ endingLinkText }}
          </SimpleLink>
        </div>
        <div class="explanation__date">
          {{ date }}
        </div>
      </div>
    </div>
    <div
      class="notification-toast__second-half
      flex gap-4 h-4"
    >
      <button
        class="rotate-45 transform-gpu"
        @click="onRemove"
      >
        <span class="iconify svg--accordion-open text-xs text-EXPONDO-grey" />
      </button>
    </div>
  </div>
</template>

<script lang="ts">

import type { NotificationStatus } from '~~/types/components/Notification/NotificationStatus';
import { NOTIFICATION_STATUS } from '~~/types/components/Notification/NotificationStatus';
import { ButtonTextSize } from '~~/types/components/Buttons/ButtonTextSize';
import { notificationCssClasses } from '~~/helpers/notifications/notificationCssClasses';

export default defineComponent({
  name: 'NotificationToast',
  props: {
    id: {
      type: String,
      required: true,
    },
    status: {
      type: String as PropType<NotificationStatus>,
      default: NOTIFICATION_STATUS.info,
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    endingLinkText: {
      type: String,
      default: '',
    },
    endingLinkSlug: {
      type: String,
      default: '',
    },
    date: {
      type: String,
      default: '',
    },
  },
  setup(props) {

    const { removeUiNotification } = useUiNavigationStore();
    const onRemove = () => {

      removeUiNotification(props.id);
    
    };

    const borderColor = computed(() => notificationCssClasses[props.status]?.border || '');
    const backgroundColor = computed(() => notificationCssClasses[props.status]?.background || '');
    const iconClass = computed(() => notificationCssClasses[props.status]?.icon || '');

    return {
      borderColor,
      backgroundColor,
      iconClass,
      ButtonTextSize,
      onRemove,
    };
  
  },
});

</script>
